<template>
    <div class="conteudoTable">
            <p  class="txtDadosG">Dados dos Produtos e Serviços</p>
            <div class="dadosGerais" style="display:block;">
                <div class="gridT ad">
                    <div>

                    </div>
                    <div>
                        Num
                    </div>                   
                    <div>
                        Descrição
                    </div>
                    <div>
                        Qtd
                    </div>
                    <div>
                         Unidade Central
                    </div>
                     <div>
                         Valor (R$)
                    </div>
                </div >          
                <div v-for="(n,i) in exibir" :key="i">
                  <div  class="gridT" >                       
                            <div style="display: flex;    justify-content: center;    align-items: center;" >
                                <div class="maisM" @click="n.visible = !n.visible">
                                    <span>+</span>
                                </div>
                            </div>
                            <div class="qa" style="text-align:center;">
                                    {{i+1}}
                            </div>
                            <div class="qa">
                                {{n.descricao}}
                            </div>
                            <div class="qa">
                               {{n.quantidadeComercial}}
                            </div>
                            <div class="qa">
                                {{n.unidadeComercial}}
                            </div>
                            <div class="qa">
                                {{n.valorTotal}}
                            </div>
                  </div>   
                  
                  <div :class="{exiNot:true,exibir:n.visible}" style="border: 1px solid #707070;margin-bottom: 20px;border-radius: 5px;padding: 15px;">
                       <div class="dadosGerais">                                   
                            <div style="flex-direction:column; width:33%;">
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Código do Produto</label><br>
                                    <input type="text"  readonly v-model="n.codigo" >
                                </div>
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Indicador de Escala Relevante</label><br>
                                    <input type="text"  readonly v-model="n.dado" >
                                </div>
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Código EX da TIPI</label><br>
                                    <input type="text"  readonly v-model="n.dado" ref="">
                                </div>
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Valor do Desconto</label><br>
                                    <input type="text"  readonly v-model="n.dado" >
                                </div>
                            </div>
                            <div style="flex-direction:column;width:33%;">
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Código NCM</label><br>
                                    <input type="text"  readonly v-model="n.ncm" >
                                </div>
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">CNPJ do Fabricante da Mercadoria</label><br>
                                    <input type="text"  readonly v-model="n.dado" >
                                </div>
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">CFOP</label><br>
                                    <input type="text"  readonly v-model="n.cfop" >
                                </div>
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Valor Total do Frete</label><br>
                                    <input type="text"  readonly v-model="n.valorFrete" >
                                </div>
                            </div> 
                            <div style="flex-direction:column;width:33%;">
                                <div   :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Código CEST</label><br>
                                    <input type="text"  readonly v-model="n.dado"  >
                                </div>
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Código de Benefício Fiscal na UF</label><br>
                                    <input type="text"  readonly v-model="n.dado" ref="">
                                </div>
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Outras Despesas Acessórias</label><br>
                                    <input type="text"  readonly v-model="n.dado" >
                                </div>
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Valor do Seguro</label><br>
                                    <input type="text"  readonly v-model="n.dado" >
                                </div>
                            </div>                       
                       </div>
                        <div class="dadosGerais" style="display:block;margin-top:15px;">  
                            <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">Indicador de Composição do Valor Total da NF-e</label><br>
                                    <input type="text"  readonly v-model="n.dado" ref="">
                            </div>   
                            <div style="display:flex; justify-content: space-between;">                              
                                <div style="flex-direction:column; width:33%;">
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Código EAN Comercial</label><br>
                                        <input type="text"  readonly v-model="n.codigoEANComercial" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Código EAN tributável</label><br>
                                        <input type="text"  readonly v-model="n.codigoEANTributavel" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Valor unitário de comercialização</label><br>
                                        <input type="text"  readonly v-model="n.valorUnitarioComercial" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Número do pedido de compra</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                </div>
                                <div style="flex-direction:column;width:33%;">
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Unidade Comercial</label><br>
                                        <input type="text"  readonly v-model="n.unidadeComercial" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Unidade Tributável</label><br>
                                        <input type="text"  readonly v-model="n.unidadeTributavel" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Valor unitário de tributação</label><br>
                                        <input type="text"  readonly v-model="n.valorUnitarioTributavel" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Item do pedido de compra</label><br>
                                        <input type="text"  readonly v-model="n.dado"  >
                                    </div>
                                </div> 
                                <div style="flex-direction:column;width:33%;">
                                    <div   :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Quantidade Comercial</label><br>
                                        <input type="text"  readonly v-model="n.quantidadeComercial" ref="">
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Quantidade Tributável</label><br>
                                        <input type="text"  readonly v-model="n.quantidadeTributavel" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Número da FCI</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Valor Aproximado dos Tributos</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                </div> 
                            </div>  
                            <div v-if="n.rastro.length > 0">
                                <p class="txtDadosG" style="text-align:left;">Rastro</p>     
                                <div  style="border: 1px solid #707070;padding: 10px;border-radius: 5px;display:flex; justify-content: space-between;">
                                    <div :style="{'width':'19.5%', 'margin-top':7+'px'}"> 
                                        <label for="">Número do Lote do Produto</label><br>
                                        <input type="text"  readonly v-model="n.rastro.numeroLote" >
                                    </div>
                                    <div :style="{'width':'19.5%', 'margin-top':7+'px'}"> 
                                        <label for="">Quantidade de Produto no Lote</label><br>
                                        <input type="text"  readonly v-model="n.rastro.quantidadeLote"  >
                                    </div>
                                    <div :style="{'width':'19.5%', 'margin-top':7+'px'}"> 
                                        <label for="">Data de fabricação/produção</label><br>
                                        <input type="text"  readonly v-model="n.rastro.dataFabricacao" >
                                    </div>
                                    <div :style="{'width':'19.5%', 'margin-top':7+'px'}"> 
                                        <label for="">Data de Validade</label><br>
                                        <input type="text"  readonly v-model="n.rastro.dataValidade" >
                                    </div>
                                    <div :style="{'width':'19.5%', 'margin-top':7+'px'}"> 
                                        <label for="">Código de Agregação</label><br>
                                        <input type="text"  readonly v-model="n.rastro.codigoAgregacao" >
                                    </div>
                                </div>  
                            </div>
                            <p class="txtDadosG" style="text-align:left;">ICMS Normal e ST</p>     
                            <div  style="border: 1px solid #707070;padding: 10px;border-radius: 5px;">
                                <div style="display:flex;justify-content: space-between;">
                                    <div style="flex-direction:column; width:39%;">
                                        <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                            <label for="">Origem da Mercadoria</label><br>
                                            <input type="text"  readonly v-model="n.imposto.icms.origem" >
                                        </div>
                                    </div>
                                    <div style="flex-direction:column; width:59%;">
                                        <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                            <label for="">Código de Situação da Operação ? Simples Nacional</label><br>
                                            <input type="text"  readonly  v-model="n.imposto.icms.codigo"  >
                                        </div>
                                    </div>
                                </div>
                                 <div style="display:flex;justify-content: space-between;">
                                    <div style="flex-direction:column; width:39%;">
                                        <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                            <label for="">Alíquota aplicável de cálculo do crédito</label><br>
                                            <input type="text"  readonly v-model="n.imposto.icms.aliquota"  >
                                        </div>
                                    </div>
                                    <div style="flex-direction:column; width:59%;">
                                        <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                            <label for="">Valor de Crédito do ICMS</label><br>
                                            <input type="text"  readonly v-model="n.imposto.icms.valor"  >
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <p v-if="false" class="txtDadosG" style="text-align:left;">Imposto Sobre Produtos Industrializados</p>     
                            <div v-if="false" style="border: 1px solid #707070;padding: 10px;border-radius: 5px;display:flex; justify-content: space-between;"> 
                                <div style="flex-direction:column; width:33%;">
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Classe de Enquadramento</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">CNPJ do Produtor</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Qtd Total Unidade Padrão</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Base de Cálculo</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                </div>
                                <div style="flex-direction:column;width:33%;">
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Código de Enquadramento</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Qtd. Selo</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Valor por Unidade</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Alíquota</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                </div> 
                                <div style="flex-direction:column;width:33%;">
                                    <div   :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Código do Selo</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">CST</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>
                                    <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                        <label for="">Valor IPI</label><br>
                                        <input type="text"  readonly v-model="n.dado" >
                                    </div>                                
                            </div>   
                            </div>  
                            <p class="txtDadosG" style="text-align:left;">PIS</p>     
                            <div  style="border: 1px solid #707070;padding: 10px;border-radius: 5px;"> 
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">CST</label><br>
                                    <input type="text"  readonly v-model="n.imposto.pis.cst" >
                                </div>   
                                <div style="display:flex; justify-content: space-between;"> 
                                    <div :style="{'width':'33%', 'margin-top':7+'px'}"> 
                                        <label for="">Base de Cálculo</label><br>
                                        <input type="text"  readonly v-model="n.imposto.pis.baseCalculo" >
                                    </div>
                                    <div :style="{'width':'33%', 'margin-top':7+'px'}"> 
                                        <label for="">Alíquota (%)</label><br>
                                        <input type="text"  readonly v-model="n.imposto.pis.aliquota" >
                                    </div>
                                    <div :style="{'width':'33%', 'margin-top':7+'px'}"> 
                                        <label for="">Valor do PIS</label><br>
                                        <input type="text"  readonly v-model="n.imposto.pis.valor" >
                                    </div>                                   
                                </div>
                            </div> 
                             <p class="txtDadosG" style="text-align:left;">COFINS</p>     
                            <div  style="border: 1px solid #707070;padding: 10px;border-radius: 5px;"> 
                                <div :style="{'width':'100%', 'margin-top':7+'px'}"> 
                                    <label for="">CST</label><br>
                                    <input type="text"  readonly v-model="n.imposto.cofins.cst">
                                </div>   
                                <div style="display:flex; justify-content: space-between;"> 
                                    <div :style="{'width':'33%', 'margin-top':7+'px'}"> 
                                        <label for="">Base de Cálculo</label><br>
                                        <input type="text"  readonly v-model="n.imposto.cofins.cst" >
                                    </div>
                                    <div :style="{'width':'33%', 'margin-top':7+'px'}"> 
                                        <label for="">Alíquota (%)</label><br>
                                        <input type="text"  readonly v-model="n.imposto.cofins.aliquota" >
                                    </div>
                                    <div :style="{'width':'33%', 'margin-top':7+'px'}"> 
                                        <label for="">Valor do PIS</label><br>
                                        <input type="text"  readonly v-model="n.imposto.cofins.valor" >
                                    </div>                                   
                                </div>
                            </div>        
                       </div>
                  </div>  
                        
                </div>              
            </div>
    </div>
</template>

<script>

export default {
props:['table'],
    data(){
        return{
            exibir:[],
        }
    },
    methods:{
       
    },
    mounted(){
        this.table.forEach(element => {
            this.exibir.push({...element,visible:false})
        });
        console.log(this.exibir)
    }
}
</script>

<style>
.exiNot{
    display: none;
}
.exibir{
    display: block;
}
.maisM{
   background: #fff; padding: 2px;display: flex;border: 2px solid #06938a;height:21px; justify-content: center;align-items: center;font-weight: bold;border-radius: 0px;cursor: pointer;
}
.maisM span{
    font-weight: bold;
}
.ad{
    
    font-weight: 600;
    color:#009188;
}
div.dadosGerais table{
    width: 100%;
} 
div.dadosGerais table  .p{
    border-bottom: 2px solid #06938A;
}
div.dadosGerais table .p td{
    color:#009188;
    font-weight: 600;
}
div.dadosGerais table  td{
    font-weight: 600;
}
.qa{
    padding: 7px 5px;
    border-radius: 5px;
    border: 2px solid #06938a;
        font-size: 14px;
    background: #fff;
    margin:1px;
}
.gridT{
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 20px 40px 1fr 80px 130px 110px;
    font-size: 15px;
}
</style>